import React, { ChangeEvent } from "react";
import { V2 } from "../../Api";
import ConfirmationDialog from "../ConfirmationDialog";

import withTitle from "../withTitle";

interface ISurgeryDocumentPrintingViewState {
    isLoading: boolean | string;
    isPrintDialogOpen: boolean;

    collections: any[];
    selectedCollection: any;
    printers: any[];
    selectedPrinter: string;
    printCopies: number;
}

class SurgeryDocumentPrintingView extends React.Component<{}, ISurgeryDocumentPrintingViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        const state: ISurgeryDocumentPrintingViewState = {
            isLoading: true,
            isPrintDialogOpen: false,

            collections: [],
            selectedCollection: {},
            printCopies: 1,
            printers: [],
            selectedPrinter: ""
        };

        this.state = state;

        this.formInputChanged = this.formInputChanged.bind(this);
        this.closePrintDialog = this.closePrintDialog.bind(this);
        this.sendPrintJob = this.sendPrintJob.bind(this);
    }

    public componentDidMount() {
        this.loadData();
    }

    public render() {
        return (
            <div className="viewer-root">
                <ConfirmationDialog title="Print document(s)" isOpen={this.state.isPrintDialogOpen} description={null} yesText="Print" noText="Close" onRequestClose={this.closePrintDialog} onConfirm={this.sendPrintJob} onSuccess={this.closePrintDialog}>
                    <p>Documents to print: <b>{this.state.selectedCollection.name}</b></p>
                    <div>Printer:
                        <select name="selectedPrinter" value={this.state.selectedPrinter} onChange={this.formInputChanged}>
                            <option value="">Select a printer...</option>
                            {this.state.printers.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                    </div>
                    &nbsp;
                    <div>How many copies: <input type="number" style={{ display: "inline", width: "auto" }} name="printCopies" value={this.state.printCopies} onChange={this.formInputChanged} /></div>
                </ConfirmationDialog>
                <div>
                    Select a document set below to print
                </div>
                &nbsp;
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.isLoading === true
                            ? <tr><td colSpan={10}><div className="spinner lds-dual-ring" /></td></tr>
                            : typeof this.state.isLoading === "string"
                                ? <tr><td colSpan={10} className="error-text">{this.state.isLoading}</td></tr>
                                : this.state.collections.map(a => <tr key={a.id} className="clickable" onClick={() => this.showPrintDialog(a)}>
                                    <td>{a.name}</td>
                                    <td>{a.description}</td>
                                </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }

    private formInputChanged(e: ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) {
        const value = e.currentTarget.value;
        const name = e.currentTarget.name;

        this.setState({
            [name]: value
        } as any);
    }

    private async loadData() {
        try {
            this.setState({
                isLoading: true
            });

            const [result, printerResult] = await Promise.all([
                V2.get<any>("printing/collections?type=surgerypacket"),
                V2.get<any>("printing/groups"),
            ]);

            this.setState({
                isLoading: false,
                collections: result.collections || [],
                printers: printerResult.groups || [],
                selectedPrinter: printerResult.defaultGroup?.id
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not load document collections"
            });
        }
    }

    private showPrintDialog(collection: any) {
        this.setState({
            isPrintDialogOpen: true,
            selectedCollection: collection
        });
    }

    private closePrintDialog() {
        this.setState({
            isPrintDialogOpen: false,
            selectedCollection: {},
        });
    }

    private sendPrintJob() {
        if (this.state.printCopies < 1 || !this.state.selectedPrinter || !this.state.selectedCollection?.id) {
            return new Promise<void>((resolve, reject) => { resolve(); });
        }

        const data = {
            collectionId: this.state.selectedCollection.id,
            printerGroupId: this.state.selectedPrinter,
            count: this.state.printCopies,
        };

        return V2.post<void>("printing/print", data);
    }
}

export default withTitle("Surgery Document Printing", SurgeryDocumentPrintingView);
